import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAtom } from "@effect-atom/atom-react";
import { App } from "../components/App";
import { loadDefaultsAtom } from "../atoms";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  const [, loadDefaults] = useAtom(loadDefaultsAtom);

  useEffect(() => {
    // Load default content on mount
    loadDefaults(undefined);
  }, [loadDefaults]);

  return <App />;
}
